module.exports = __webpack_public_path__ + "res/ic_reels.81311e9a6be6440f7f13849ba7ca81c6.png";